// frontend/src/features/campaign/components/list/CampaignEmptyState.js
import React from 'react';

export default function CampaignEmptyState({
  hasFilters,
  onResetFilters,
  onCreateCampaign,
  onSeedSampleCampaigns,
  isSeeding = false,
}) {
  return (
    <div className="cmp-empty-state">
      <div className="cmp-empty-icon">
        <i className="fas fa-bullhorn" />
      </div>
      <h3 className="cmp-empty-title">No campaigns found</h3>
      <p className="cmp-empty-desc">
        {hasFilters
          ? 'No campaigns matched your current search and filter criteria.'
          : 'You have not created any sales outreach campaigns in this workspace yet.'}
      </p>
      <div className="cmp-empty-actions">
        {hasFilters ? (
          <button className="cmp-btn-secondary" onClick={onResetFilters}>
            Reset Filters
          </button>
        ) : (
          onSeedSampleCampaigns && (
            <button
              type="button"
              className="cmp-btn-secondary"
              disabled={isSeeding}
              onClick={onSeedSampleCampaigns}
              title="Populate your workspace with sample outbound campaigns to explore governance and workflows"
            >
              {isSeeding ? (
                <>
                  <i className="fas fa-spinner fa-spin" /> Loading Demos...
                </>
              ) : (
                <>
                  <i className="fas fa-magic" /> Load Demo Campaigns
                </>
              )}
            </button>
          )
        )}
        <button className="cmp-btn-primary" onClick={onCreateCampaign}>
          <i className="fas fa-plus" /> Create Your First Campaign
        </button>
      </div>
    </div>
  );
}
